import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { MainContent } from './MainContent'


export const User=()=> {
  return (
    <>
    <MainDiv>
    <MainContent/>
    </MainDiv>
    </>
    
  )
}
